export default __webpack_public_path__ + "static/media/yaboi.e05c96d4.jpg";